// extracted by mini-css-extract-plugin
export var blogFullWidth = "blog_full_width-module--blogFullWidth--d54tw";